query Content($id: ID!) {
  content(id: $id) {
    id
    type
    title
    description
    processingStatus
    transcodingError
    duration
    video {
      id
      uid
      fileName
      readyToStream
      duration
      transcodingError
      isChatEnabled
    }
    pendingVideo {
      id
      uid
      fileName
      isChatEnabled
    }
    publishAt
    accessStartAt
    hideInGeneralLists
    onlyUsers
    ageRestrictions
    collectionIds
    productIds
    url
    embedUrl
    preview {
      id
      url(format: HIGH)
    }
    verticalPreview {
      id
      url
    }
    tags {
      id
      title
    }
    countryAccess {
      id
      title
    }
    widget {
      id
    }
    playback {
      token
      hlsUrl
      iframeUrl
      thumbnailUrl
    }
    createdAt
    updatedAt
  }
}
